var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.4259 4.38829L10.5876 12.227C10.4996 12.315 10.3842 12.3618 10.2689 12.3657L7.34828 12.6712C7.04983 12.7023 6.79581 12.4498 6.83166 12.142L7.13946 9.20031C7.15115 9.0881 7.20102 8.98835 7.27504 8.91432L7.27427 8.91354L15.1125 1.07484C16.0663 0.121025 17.3848 0.467007 18.2091 1.29147L18.2099 1.29069C19.0327 2.11283 19.3789 3.43531 18.4259 4.38829ZM17.6879 8.73665H16.7412V16.0758C16.7412 16.887 16.0749 17.5533 15.2638 17.5533H3.4249C2.61373 17.5533 1.9475 16.887 1.9475 16.0758V4.23628C1.9475 3.42428 2.61373 2.75879 3.4249 2.75879H10.7636V1.81197H3.4249C2.09009 1.81197 1 2.90216 1 4.23622V16.0758C1 17.4106 2.09013 18.5 3.42411 18.5H15.263C16.5978 18.5 17.6871 17.4098 17.6871 16.075L17.6879 8.73665ZM15.2403 2.28583L17.2141 4.25972L17.7556 3.71813C18.2941 3.17966 18.0034 2.42298 17.5398 1.9601L17.5406 1.95932C17.0793 1.49799 16.3195 1.20655 15.7811 1.74424L15.2403 2.28583ZM16.5447 4.92991L14.5709 2.95603L8.06045 9.4661L7.82981 11.6707L10.0343 11.44L16.5447 4.92991Z",
    fill: "#4D4D4D",
    stroke: "#4D4D4D",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditOutlined);
export default __webpack_public_path__ + "static/media/editOutlined.fe9bfbb082ded14d4f9e1746108f5070.svg";
export { ForwardRef as ReactComponent };